import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'address-lookup-status',
  providers: [AddressLookupStatusComponent],
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './address-lookup-status.component.html',
  styleUrls: ['./address-lookup-status.component.scss'],
})
export class AddressLookupStatusComponent implements OnInit {
  addressLookupUnavailable = false;

  constructor(
    private spinner: NgxSpinnerService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    // Clear any leftover spinner from the previous page, then show our own.
    this.spinner.hide();
    this.spinner.show();
  }

  public setAddressLookupUnavailable(addressLookupUnavailable: boolean) {
    this.addressLookupUnavailable = addressLookupUnavailable;
  }

  public getAddressLookupUnavailable(): boolean {
    return this.addressLookupUnavailable;
  }


  public async checkAddressLookupStatus(appConfig: any, environment: any, config: any = null) {
    let status: any = await this.loadContent(appConfig);
    if (status && status.status === true) {
      this.addressLookupUnavailable = false;
    } else {
      this.addressLookupUnavailable = true;
    }
    if (config && config.manualAddressEntryOverride === true) {
      this.addressLookupUnavailable = true; // testing
    }
    return this.addressLookupUnavailable;
  }

  private async loadContent(appConfig: any) {
    try {
      console.log("appConfig.settings", appConfig.settings)
      const headers = {
        'Content-Type': 'application/json',
        'X-BL-TOKEN': 'ccdee82532b5aa1ed2a45be61768c44639a0e8c669abec082b012bfab6e71c10',
      };
      if (appConfig.settings.addressApi.jrniApi === undefined) {
        if (appConfig.settings.apiServer.api_url.includes("staging")) {
          appConfig.settings.addressApi.jrniApi = "https://staging.bookinglab.co.uk";
        } else {
          appConfig.settings.addressApi.jrniApi = "https://api.bookinglab.co.uk";
        }
      }
      return await this.http
        .post(`${appConfig.settings.addressApi.jrniApi}/serviceStatus/osplaces`,
          {
            "host": appConfig.settings.apiServer.api_url
          },
          {
            headers,
          })
        .toPromise();
    } catch (error) {
      console.error('Error finding the address lookup status:', error);
      return null;
    }
  }
}
